<div class="modal-header mfp-header">
    <h5 class="modal-title">{{ Barrel.BarrelID ? 'Edit' : 'Create' }} Barrel</h5>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"
    ></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row my-2">
            <div class="col-12 col-md-6">Orig. BBL #:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Barrel.LegacyBarrelNumber" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Wood Type:</div>
            <div class="col-12 col-md-6">
                <select class="form-select" [(ngModel)]="Barrel.WoodType">
                    <option *ngFor="let woodType of WoodTypeValues" [ngValue]="woodType">
                        {{ WoodTypeDisplayValues[woodType] }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Is Used?</div>
            <div class="col-12 col-md-6">
                <select class="form-select" [(ngModel)]="Barrel.IsUsed">
                    <option [ngValue]="null">Unknown</option>
                    <option [ngValue]="true">Yes</option>
                    <option [ngValue]="false">No</option>
                </select>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Char:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Barrel.Char" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Toast:</div>
            <div class="col-12 col-md-6">
                <select class="form-select" [(ngModel)]="Barrel.ToastLevel">
                    <option *ngFor="let toastLevel of ToastLevelValues" [ngValue]="toastLevel">
                        {{ ToastLevelDisplayValues[toastLevel] }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Description (Char):</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Barrel.Description" />
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="Cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="Save()">Save</button>
</div>